import { render } from "./TaResources.vue?vue&type=template&id=13bbca47"
import script from "./TaResources.vue?vue&type=script&lang=js"
export * from "./TaResources.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__